module.exports = __webpack_public_path__ + "img/b8.ba8265bf.png";